<section class="community-special-topic">
    <div class="container">
        <!-- Header Section -->
        <div class="topic-header">
            <div class="header-content">
                <h1 class="page-title">
                    <i class="fas fa-newspaper"></i>
                    Special Topics
                </h1>
                <p class="page-description">
                    Explore in-depth articles and insights about food culture, traditions, and innovations.
                </p>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-container" *ngIf="isLoading">
            <div class="loading-spinner">
                <i class="fas fa-spinner fa-spin"></i>
                <p>Loading articles...</p>
            </div>
        </div>

        <!-- Articles Grid -->
        <div class="row" *ngIf="!isLoading && topicList.length > 0">
            <div class="col-lg-4" *ngFor="let item of topicList; trackBy: trackById">
                <div class="wide-card" (click)="readArticle(item)">
                    <div class="image-on">
                        <a href="javascript:void(0)">
                            <picture>
                                <img class="radius-top" [src]="item.image" [alt]="item.title"
                                    (error)="$event.target.src='assets/images/default-article.jpg'" />
                            </picture>
                            <picture>
                                <img class="image-on-image" [src]="getCategoryIcon(item.category)" [alt]="item.category"
                                    (error)="$event.target.src='assets/images/default-category.png'" />
                            </picture>
                        </a>
                    </div>
                    <div class="card-section">
                        <h4>
                            <b><a href="javascript:void(0)">{{ item.title }}</a></b>
                        </h4>
                        <p style="font-size: 1rem">{{ item.description }}</p>
                        <div class="article-meta" *ngIf="item.author || item.readTime">
                            <small *ngIf="item.author" class="text-muted">
                                <i class="fas fa-user"></i> {{ item.author }}
                            </small>
                            <small *ngIf="item.readTime" class="text-muted ml-2">
                                <i class="far fa-clock"></i> {{ item.readTime }} min read
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!isLoading && topicList.length === 0">
            <div class="empty-content">
                <i class="fas fa-newspaper"></i>
                <h3>No Articles Found</h3>
                <p>No articles are available at the moment. Check back later for new content!</p>
            </div>
        </div>

        <!-- Load More Button -->
        <div class="load-more-container" *ngIf="!isLoading && hasMoreItems && topicList.length > 0">
            <button class="load-more-btn" (click)="loadMore()" [disabled]="isLoadingMore"
                [class.loading]="isLoadingMore">
                <span *ngIf="!isLoadingMore">
                    <i class="fas fa-plus"></i>
                    Load More Articles
                </span>
                <span *ngIf="isLoadingMore">
                    <i class="fas fa-spinner fa-spin"></i>
                    Loading...
                </span>
            </button>
        </div>

        <!-- Loading More Items -->
        <div class="loading-more" *ngIf="isLoadingMore">
            <div class="loading-more-content">
                <i class="fas fa-spinner fa-spin"></i>
                <p>Loading more articles...</p>
            </div>
        </div>
    </div>
</section>

